<template>
  <div am-input-alg>
    <div class="_display:inline-flex _align-items:center">
      <i-input
        v-model="algVal"
        @keypress="noNumber"
        @change="setChange"
        :error="error"
        class="_text-transform:uppercase"
      />
      <div class="_margin-left:1/4" v-if="delAlg">
        <svg viewBox="0 0 24 24" am-icon="color" @click="$emit('delete')">
          <use xlink:href="@/assets/icons.svg#minus"  x="0" y="0" width="24" height="24"></use>
        </svg>
      </div>
    </div>
    <ul class="form-error" v-if="error">
      <li>At least 1 capital letter and 1 number</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    alg: {
      type: String,
      default: ''
    },
    delAlg: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    error: false
  }),
  computed: {
    algVal () {
      return this.alg
    }
  },
  methods: {
    noNumber (event) {
      this.error = false
      const regex = /^[A-Za-z 0-9]+$/
      const key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(key)) {
        event.preventDefault()
        return false
      }
    },
    setChange (event) {
      const data = event.target.value.toUpperCase()
      const regex = /^[A-Z]{1,}[0-9]{1,}$/g
      const found = regex.test(data)
      if (!found) {
        this.error = true
      } else this.error = false
      this.$emit('update', { data: data, error: this.error })
    }
  }
}
</script>

<style lang="scss">
[am-input-alg] {
  .input-wrapper {
    min-width: 230px;
  }
  .form-error {
    position: absolute;
  }
}
</style>
